import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPastPurchasedMember } from '_redux/modules/group';

export default function useMemberPurchases({ userId, groupId, enabled = true }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { pastPurchasedMember } = useSelector((state) => state.group);

  const currentMemberPurchases = useMemo(() => {
    if (!Array.isArray(pastPurchasedMember)) return null;
    return pastPurchasedMember.find(
      (item) => String(item.userId) === String(userId) && String(item.groupId) === String(groupId)
    );
  }, [pastPurchasedMember, userId, groupId]);

  useEffect(() => {
    let isMounted = true;
    const fetchPurchases = async () => {
      if (!enabled || !userId || !groupId) return;

      const isCached = pastPurchasedMember?.some(
        (item) => String(item.userId) === String(userId) && String(item.groupId) === String(groupId)
      );

      if (!isCached) {
        setLoading(true);
      }

      try {
        await dispatch(getPastPurchasedMember(userId, groupId));
      } catch (error) {
        console.error('Failed to fetch past purchases:', error);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchPurchases();
    return () => {
      isMounted = false;
    };
  }, [dispatch, enabled, userId, groupId, pastPurchasedMember]);

  const purchases = useMemo(() => {
    if (!currentMemberPurchases?.listOrders || !Array.isArray(currentMemberPurchases.listOrders)) {
      return [];
    }

    return currentMemberPurchases.listOrders.map((item) => {
      const price = item?.pPrice && item?.pQuantity ? item.pPrice * item.pQuantity : 0;
      return {
        ...item,
        totalPrice: price,
      };
    });
  }, [currentMemberPurchases]);

  return {
    purchases,
    loading,
    hasPurchases: purchases.length > 0,
  };
}
